// Mock data for ISOFLAM SARL Landing Page

export const companyInfo = {
  name: "ISOFLAM SARL",
  tagline: "Professionalism and experience at your disposal!",
  address: "8 Rue de l'Industrie, L-4150 Esch-sur-Alzette LUXEMBOURG",
  phone: "+352 26 54 34 46",
  phone2: "+352 621 472 338",
  email: "isoflam@internet.lu",
  experience: "20 years"
};

export const services = [
  {
    id: 1,
    title: "Waterproofing",
    description: "Execution of all types of work related to waterproofing. Waterproofing of flat terraces is important to preserve its quality.",
    features: [
      "Synthetic membranes",
      "Bituminous waterproofing",
      "Asphalt waterproofing"
    ],
    image: "https://images.unsplash.com/photo-1635424824849-1b09bdcc55b1",
    icon: "Droplets"
  },
  {
    id: 2,
    title: "Insulation",
    description: "All types of work related to insulation including polyurethane, extruded polystyrene, and expanded glass foam.",
    features: [
      "Polyurethane",
      "Extruded polystyrene",
      "Expanded glass (Foamglas)"
    ],
    image: "https://images.unsplash.com/photo-1589939705384-5185137a7f0f",
    icon: "Layers"
  },
  {
    id: 3,
    title: "Roofing",
    description: "Roofing is essential for a warm and dry house. We protect, seal, and insulate roofing composed of several elements forming successive layers.",
    features: [
      "Aesthetic roofing",
      "Waterproof solutions",
      "Ecological and sustainable"
    ],
    image: "https://images.unsplash.com/photo-1635424709845-3a85ad5e1f5e",
    icon: "Home"
  }
];

export const statistics = [
  { label: "Quality", value: "100%", subtitle: "Proven" },
  { label: "Trust", value: "100%", subtitle: "Absolute" },
  { label: "Security", value: "100%", subtitle: "Assured" },
  { label: "Clients", value: "1023", subtitle: "Satisfied" }
];

export const testimonials = [
  {
    id: 1,
    name: "Marc Dubois",
    company: "Residential Client",
    content: "Excellent work on our flat roof waterproofing. The team was professional, punctual, and the quality is outstanding. Highly recommended!",
    rating: 5
  },
  {
    id: 2,
    name: "Sophie Laurent",
    company: "Commercial Property Owner",
    content: "ISOFLAM completed our commercial building insulation project ahead of schedule. Their attention to detail and expertise is remarkable.",
    rating: 5
  },
  {
    id: 3,
    name: "Jean Weber",
    company: "Construction Manager",
    content: "We've worked with ISOFLAM on multiple projects. Their certified expertise and commitment to quality make them our go-to partner.",
    rating: 5
  }
];

export const faqs = [
  {
    id: 1,
    question: "What types of waterproofing do you specialize in?",
    answer: "We specialize in all types of waterproofing including synthetic membranes, bituminous waterproofing, and asphalt waterproofing. Our certified team has over 10 years of experience in flat roof waterproofing."
  },
  {
    id: 2,
    question: "How long does a typical roofing project take?",
    answer: "Project duration varies based on size and complexity. A typical residential roofing project takes 3-7 days, while commercial projects may take 2-4 weeks. We provide detailed timelines during consultation."
  },
  {
    id: 3,
    question: "Do you offer guarantees on your work?",
    answer: "Yes! We offer a 100% guarantee on all our services and products. Our work is backed by our commitment to quality and our certified expertise in waterproofing and insulation."
  },
  {
    id: 4,
    question: "What insulation materials do you use?",
    answer: "We work with high-quality insulation materials including polyurethane, extruded polystyrene, and expanded glass foam (Foamglas). We recommend the best solution based on your specific needs."
  },
  {
    id: 5,
    question: "Are you certified and insured?",
    answer: "Absolutely. We are a certified waterproofing company with all necessary licenses and comprehensive insurance. Our team follows strict safety protocols on every project."
  },
  {
    id: 6,
    question: "Do you provide free estimates?",
    answer: "Yes, we provide free, no-obligation estimates for all projects. Contact us via phone or our contact form to schedule a consultation."
  }
];

export const aboutContent = {
  title: "About ISOFLAM SARL",
  description: "Isoflam is a specialized company in waterproofing of flat terraces. With 10 years of experience in the field and certified as a waterproof installer, we have earned the trust of our clients to protect their property and provide them with a reliable market reference in Luxembourg.",
  values: "Our values are simple: quality and rigor at work!",
  highlights: [
    "Certified waterproofing specialists",
    "Over 10 years of experience",
    "Trusted by 1000+ clients",
    "100% satisfaction guarantee"
  ]
};

// Mock function to simulate form submission
export const submitContactForm = async (formData) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      console.log('Mock form submission:', formData);
      resolve({ success: true, message: 'Form submitted successfully!' });
    }, 1000);
  });
};